import { ComponentRef, Injectable, ViewContainerRef, WritableSignal, signal, inject } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { ModalComponent } from '@molecules/modal/modal.component';
import { SsrService } from '@services/ssr.service';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private ssrService = inject(SsrService);
  public opened: WritableSignal<boolean> = signal(false);
  private componentRef: ComponentRef<ModalComponent>[] = [];
  private componentSubscriber: Subject<string>[] = [];
  private entry?: ViewContainerRef;

  setEntry(entry: ViewContainerRef): void {
    this.entry = entry;
  }

  open(data: any, size?: 'min' | 'small' | 'medium' | 'large', close?: 'right' | 'left'): Observable<string> | undefined {
    if (!this.entry) return;
    this.opened.set(true);
    const index: number = this.componentRef.length;
    this.componentRef[index] = this.entry.createComponent(ModalComponent);
    this.componentRef[index].instance.data = data;
    this.componentRef[index].instance.size = size;
    if (close) this.componentRef[index].instance.closePosition = close;
    this.componentSubscriber[index] = new Subject<string>();
    return this.componentSubscriber[index].asObservable();
  }

  close(): void {
    if (this.ssrService.isServer()) return;
    if (document.querySelectorAll('app-modal').length <= 1) this.opened.set(false);
    const index: number = this.componentRef.length - 1;
    this.componentSubscriber[index]?.complete();
    this.componentRef[index]?.destroy();
    this.componentRef.splice(index, 1);
    this.componentSubscriber.splice(index, 1);
  }
}
